import logger from "@utils/logger";
import { refreshAccessToken } from "@services/auth"; // <-- your existing function
const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;

async function syncMeToLocalStorage() {
  const token = localStorage.getItem("access_token");
  if (!token) return;

  const res = await fetch(`${backendUrl}/auth/me`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) return;

  const payload = await res.json();
  const me = payload?.data;

  localStorage.setItem("permission_preset", me?.permission_preset ?? "");
  localStorage.setItem("is_owner", me?.is_owner ? "true" : "false");
  localStorage.setItem("role", me?.role ?? "");
  window.dispatchEvent(new Event("permissions-updated"));
}

export function installFetchInterceptor() {
  if (window.__FETCH_INTERCEPTOR_INSTALLED__) return;
  window.__FETCH_INTERCEPTOR_INSTALLED__ = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
    const isAuthRefresh = url?.includes("/auth/refresh");
    const isAuthMe = url?.includes("/auth/me");

    const hasToken = !!localStorage.getItem("access_token");

    // ✅ Only handle permission mismatch scenario
    if (response?.status === 401 && hasToken && !isAuthRefresh && !isAuthMe) {
      let data = null;
      try {
        data = await response.clone().json();
      } catch (_) {}

      const isPermissionMismatch =
        data?.details?.includes("Session permissions changed");

      if (isPermissionMismatch) {
        logger.warn("Permission mismatch detected → refreshing token...");

        try {
          // 1) refresh token (gets a new access token with updated claims)
          await refreshAccessToken();

          // 2) sync /auth/me into localStorage (permission_preset / is_owner / role)
          await syncMeToLocalStorage();

          // 3) retry the original request once, now with updated token
          return await originalFetch(...args);
        } catch (e) {
          logger.error(`Recovery failed: ${e?.message || e}`);
          // At this point, you can optionally logout
        }
      }
    }

    return response;
  };

  logger.info("Global fetch interceptor installed (401 permission mismatch → refresh → retry)");
}
